import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=270e47f2&scoped=true&"
import script from "./paper.vue?vue&type=script&lang=js&"
export * from "./paper.vue?vue&type=script&lang=js&"
import style0 from "./paper.vue?vue&type=style&index=0&id=270e47f2&lang=scss&scoped=true&"
import style1 from "./paper.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e47f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsToastBox: require('/usr/app/src/components/ns/NsToastBox.vue').default})
